import { render } from "./BatchStatusChip.vue?vue&type=template&id=6a00bb40&scoped=true"
import script from "./BatchStatusChip.vue?vue&type=script&lang=js"
export * from "./BatchStatusChip.vue?vue&type=script&lang=js"

import "./BatchStatusChip.vue?vue&type=style&index=0&id=6a00bb40&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a00bb40"]])

export default __exports__